import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGithub } from '@fortawesome/free-brands-svg-icons'
import clsx from 'clsx'
import { buttonVariants } from '@react/shared/ui/Button'
import { ticketTone } from '../helpers'

const TicketRow = ({ ticket }) => (
  <li className="flex flex-wrap items-center gap-x-3 gap-y-2 py-2.5">
    <div className="min-w-0 flex-1 basis-full sm:basis-0">
      <div className="truncate text-[13.5px] font-semibold leading-snug text-slate-900">{ticket.account || `Ticket #${ticket.id}`}</div>
      <div className="truncate text-[12.5px] leading-snug text-slate-500">#{ticket.id} · {ticket.title}</div>
    </div>
    <span className={clsx('tw-chip', ticketTone(ticket.status))}>{ticket.status_label}</span>
    <a
      href={ticket.url}
      target="_blank"
      rel="noopener noreferrer"
      className={clsx(buttonVariants({ variant: 'primary', size: 'sm' }), 'no-underline hover:text-white hover:no-underline focus:text-white')}
    >
      Ouvrir le ticket
      <FontAwesomeIcon icon="arrow-up-right-from-square" className="text-[10px]" />
    </a>
  </li>
)

const ProductionView = ({ issues, loading, searching, onOpenIssue }) => {
  if (loading && !issues) {
    return <div className="flex justify-center py-12 text-slate-400"><FontAwesomeIcon icon="circle-notch" spin size="2x" /></div>
  }
  if (!issues) return null

  return (
    <div className="mx-auto w-full max-w-[980px] space-y-3 lg:min-h-0 lg:overflow-y-auto lg:pr-1">
      <div className="flex items-start gap-3 rounded-xl border-[1px] border-emerald-200 bg-emerald-50 px-[16px] py-[12px] text-[13px] text-emerald-900">
        <FontAwesomeIcon icon="rocket" className="mt-0.5 text-emerald-600" />
        <p className="m-0">
          Ces demandes sont en production : prévenez chaque client depuis son ticket. Une demande quitte
          cette liste quand sa carte est archivée sur GitHub.
        </p>
      </div>

      {issues.length === 0 && (
        <div className="rounded-2xl bg-white px-[20px] py-12 text-center text-[13.5px] text-slate-500">
          {searching ? 'Modifiez la recherche pour afficher d’autres demandes.' : 'Les demandes en production s’affichent ici.'}
        </div>
      )}

      {issues.map(issue => (
        <article key={issue.number} className="rounded-2xl border-[1px] border-slate-200 bg-white px-6 py-[16px]">
          <div className="flex flex-wrap items-center gap-1.5">
            <button
              type="button"
              onClick={() => onOpenIssue(issue.number)}
              title="Voir le ticket GitHub"
              className="tw-chip cursor-pointer border-0 bg-purple-100 font-sans text-purple-800 hover:bg-purple-200 focus:outline-none"
            >
              <FontAwesomeIcon icon={faGithub} className="text-[10px] opacity-70" />
              #{issue.number}
            </button>
            <span className="tw-chip bg-emerald-100 text-emerald-800">
              <FontAwesomeIcon icon="rocket" className="text-[9px] opacity-70" />
              En production
            </span>
            {!issue.to_announce && issue.tickets.length > 0 && (
              <span className="tw-chip bg-slate-100 text-slate-700">
                <FontAwesomeIcon icon="check" className="text-[9px] opacity-70" />
                Tickets terminés
              </span>
            )}
          </div>
          <h2 className="m-0 mt-2 text-[15px] font-bold leading-snug tracking-tight text-slate-900">{issue.title}</h2>
          {issue.tickets.length > 0 && (
            <ul className="m-0 mt-2 list-none divide-y divide-slate-100 p-0">
              {issue.tickets.map(ticket => <TicketRow key={ticket.id} ticket={ticket} />)}
            </ul>
          )}
        </article>
      ))}
    </div>
  )
}

export default ProductionView
